const PhpErrorsData = [
  {
    content:
      'PHP Fatal error:  Uncaught Error: Call to undefined function test() in /home2/xxyggute/public_html/index.php:15\nStack trace:\n#0 {main}\n  thrown in /home2/xxyggute/public_html/index.php on line 15\n',
    date: '23-Apr-2025 12:49:25 America/Boise',
  },
  {
    content:
      'PHP Fatal error:  Uncaught Error: Call to undefined function test() in /home2/xxyggute/public_html/index.php:15\nStack trace:\n#0 {main}\n  thrown in /home2/xxyggute/public_html/index.php on line 15\n',
    date: '23-Apr-2025 12:49:44 America/Boise',
  },
  {
    content:
      'PHP Fatal error:  Uncaught Error: Call to undefined function test() in /home2/xxyggute/public_html/index.php:15\nStack trace:\n#0 {main}\n  thrown in /home2/xxyggute/public_html/index.php on line 15\n',
    date: '23-Apr-2025 12:49:51 America/Boise',
  },
];

export default PhpErrorsData;
